import React, { useState, useEffect, useRef } from 'react';
import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import '../../scss/style.scss'
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css"; // Importar estilos

import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CForm,
  CFormLabel,
  CFormInput,
  CFormSelect,
  CFormTextarea,
  CCollapse,
  CToast,
  CToastBody,
  CToastClose,
  CSpinner,
  CModal,
  CModalContent,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'

import {
  cilArrowLeft,
  cilCalendar,
} from '@coreui/icons'

import iconCheck from '../../assets/images/check.png'
import iconArrowUp from '../../assets/images/up-arrowhead-in-a-circle.png'
import iconArrowDown from '../../assets/images/down-arrowhead-in-a-circle.png'
import iconImagenUpload from '../../assets/images/icon-imagen-upload.png'
import trash from '../../assets/images/trash.png'

function CustomInput({ value, onChange, onFocus }) {
  const inputRef = useRef(null);

  return (
    <div className="input-group">
      <CFormInput
        className="letra-contenido-modal-input"
        size="sm"
        placeholder="Seleccione fecha"
        value={value}
        readOnly
        ref={inputRef}
      //onClick={() => onFocus(inputRef.current)} // Abre el DatePicker al hacer clic en el input
      />
      <div className="input-group-append">
        <span className="input-group-text" onClick={() => onFocus(inputRef.current)}>
          <CIcon
            icon={cilCalendar}
            size="lg"
            className="height-auto"
            style={{ "--ci-primary-color": "black" }}
          />
        </span>
      </div>
    </div>
  );
}

function FormVideo({ profile, setProfile }) {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(null);
  const [visible2, setVisible2] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null); // Inicializar con la fecha 
  const [selectedDate2, setSelectedDate2] = useState(null); // Inicializar con la fecha2
  const [idProyecto, setidProyecto] = useState(null);
  const [idCarreteras, setIdCarreteras] = useState(null);
  const [nombreProyecto1, setNombreProyecto1] = useState(null);
  const [alturaCenital1, setAlturaCenital1] = useState(null);
  const [cliente1, setCliente1] = useState(null);
  const [operador1, setOperador1] = useState(null);
  const [descripcion1, setDescripcion1] = useState(null);
  const [carreteraIndex, setCarreteraIndex] = useState(0); // Nuevo estado para guardar el 
  const datePickerRef = useRef(null); // Referencia para el DatePicker
  const datePickerRef2 = useRef(null); // Referencia para el DatePicker
  // const [registro, setRegistro] = useState({});
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dataProyecto, setDataProyecto] = useState(null);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showRequiredToast, setRequiredErrorToast] = useState(false);
  // const [collapseVisible, setCollapseVisible] = useState(false);

  const [carreteras, setCarreteras] = useState([
    {
      id: Date.now(),
      nombre: '',
      tipo: '',
      cantCarriles: '',
      concesion: '',
      isNew: 1
    }
  ]);

  const [formularioCarretera, setFormularioCarretera] = useState({
    id: Date.now(),
    nombre: '',
    tipo: '',
    cantCarriles: '',
    concesion: '',
    isNew: 1,
  });

  const [errors, setErrors] = useState({
    nombreProyecto1: '',
    alturaCenital1: '',
    selectedDate: '',
    selectedDate2: '',
    cliente1: '',
    operador1: '',
    // ... Errores para los campos de carretera
  });

  // Función para validar los campos
  const validarFormulario = () => {
    let newErrors = {};

    // Validar campos de Proyecto
    if (!nombreProyecto1) {
      newErrors.nombreProyecto1 = 'Este campo es obligatorio';
      setRequiredErrorToast(true)
    }
    if (!alturaCenital1) {
      newErrors.alturaCenital1 = 'Este campo es obligatorio';
      setRequiredErrorToast(true)
    }
    if (!selectedDate) {
      newErrors.selectedDate = 'Este campo es obligatorio';
      setRequiredErrorToast(true)
    }
    if (!selectedDate2) {
      newErrors.selectedDate2 = 'Este campo es obligatorio';
      setRequiredErrorToast(true)
    }
    if (!cliente1) {
      newErrors.cliente1 = 'Este campo es obligatorio';
      setRequiredErrorToast(true)
    }
    if (!operador1) {
      newErrors.operador1 = 'Este campo es obligatorio';
      setRequiredErrorToast(true)
    }

    carreteras.forEach((carretera, carreteraIndex) => {
      if (!carretera.nombre) { // Validar el campo nombre de la carretera
        newErrors[`nombreCarreteraError${carreteraIndex}`] = 'Este campo es obligatorio';
        setRequiredErrorToast(true)
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Retorna true si no hay errores
  };


  const handleGoBack = () => {
    navigate(-1); // Navega a la página anterior
  };

  const handleFocus = (element) => {
    if (datePickerRef.current) {
      datePickerRef.current.focus(); // Ajusta el foco para abrir el DatePicker
    }
  };
  const handleFocus2 = (element) => {
    if (datePickerRef2.current) {
      datePickerRef2.current.focus(); // Ajusta el foco para abrir el DatePicker
    }
  };


  const handleCloseToast = (element) => {
    setShowSuccessToast(false);
  }
  const handleCloseToastError = (element) => {
    setShowErrorToast(false);
  }

  const handlerequiredFields = (element) => {
    setRequiredErrorToast(false);
  }


  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true); // Muestra un indicador de carga mientras se realiza la solicitud

      try {
        const token = localStorage.getItem('token');

        if (!token) {
          throw new Error('Token no disponible en localStorage'); // Manejar el caso en el que no haya token
        }

        // Realiza la solicitud a la API con el token en los headers
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/edit/project/${id}`, {
          headers: {
            'Authorization': 'Bearer ' + token
          }
        });

        // Si la respuesta no es correcta, lanza un error
        if (!response.ok) {
          if (response.status === 401) {
            // Token inválido o expirado
            console.error("Error 401: No autorizado");
            // Redirige al inicio de sesión, limpia el token, etc.
            localStorage.removeItem('token');
            window.location.href = '/login'; // Ajusta la ruta si es necesario 
          } else {
            // Otros errores
            throw new Error(`Error ${response.status}: ${response.statusText}`);
          }
        }

        // Obtén los datos JSON de la respuesta
        const jsonData = await response.json();
        // console.log('Datos JSON recibidos:', jsonData); // Imprime los datos recibidos

        // Actualiza el estado de dataProyecto con los datos recibidos
        setDataProyecto(jsonData);

        // Guarda los datos en el localStorage si es necesario
        localStorage.setItem('data-proyecto', JSON.stringify(jsonData));

      } catch (error) {
        console.error('Error durante la solicitud:', error); // Manejo de errores
        setError(error); // Guarda el error en el estado para mostrarlo en la interfaz
      } finally {
        setIsLoading(false); // Detén el indicador de carga
      }
    };

    fetchData(); // Llama a la función fetchData cuando el componente se monte o cambie el id

    // Este useEffect se ejecutará siempre que cambie `id` y asegurará que los datos se recarguen
  }, [id]);

  useEffect(() => {
    if (dataProyecto) {
      if (dataProyecto.proyecto) {
        // Carga información del proyecto
        setidProyecto(dataProyecto.proyecto[0].id);
        setNombreProyecto1(dataProyecto.proyecto[0].nombre);
        setAlturaCenital1(dataProyecto.proyecto[0].altura_cenital);
        setCliente1(dataProyecto.proyecto[0].cliente)
        setOperador1(dataProyecto.proyecto[0].operador)
        setDescripcion1(dataProyecto.proyecto[0].descripcion)
        setSelectedDate(new Date(dataProyecto.proyecto[0].fecha_inicio));
        setSelectedDate2(new Date(dataProyecto.proyecto[0].fecha_fin));
      }

      // Carga información de las carreteras
      if (dataProyecto.carretera && dataProyecto.carretera.length > 0) {
        setCarreteras(dataProyecto.carretera.map((c, index) => {
          const carreteraData = {
            id: c.id,
            nombre: c.nombre,
            tipo: c.tipo,
            cantCarriles: c.cant_carriles,
            concesion: c.concesion,
            isNew: c.isNew
          };
          return carreteraData;
        }));

        // Inicializa carreteraIndex
        setCarreteraIndex(dataProyecto.carretera.length);
      } else {
        setCarreteras([]);
      }
    }
  }, [dataProyecto, id]);

  useEffect(() => {
    if (carreteraIndex === 0) {
      setCarreteraIndex(1);
    }
  }, [carreteraIndex]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validarFormulario()) { // Validar antes de envia
      setIsLoading(true);

      // Convierte las fechas a formato ISO
      const formatDate = (date) => date?.toISOString().slice(0, 19).replace('T', ' ');
      let fechaInicio1 = formatDate(selectedDate);
      let fechaFin1 = formatDate(selectedDate2);

      // Crea un objeto de proyecto con la estructura adecuada
      const proyecto = {
        idProyecto,
        nombreProyecto1,
        alturaCenital1,
        fechaInicio1,
        fechaFin1,
        cliente1,
        operador1,
        descripcion1,
        carreteras: []
      };

      // Agrega las carreteras al proyecto
      carreteras.forEach((carretera) => {
        const carreteraData = {
          id: carretera.id,
          nombre: carretera.nombre,
          tipo: carretera.tipo,
          cantCarriles: carretera.cantCarriles,
          concesion: carretera.concesion,
          isNew: carretera.isNew
        };

        proyecto.carreteras.push(carreteraData);
      });

      try {
        const token = localStorage.getItem('token');
        const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/update/project`, proyecto, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json', // Ahora envía JSON
            'Authorization': 'Bearer ' + token
          }
        });

        // ... (Resto del manejo de la respuesta)
        setShowSuccessToast(true);
      } catch (error) {
        if (error.response.status === 401) {
          // Token inválido o expirado
          console.error("Error 401: No autorizado");
          // Redirige al inicio de sesión, limpia el token, etc.
          localStorage.removeItem('token');
          window.location.href = '/login'; // Ajusta la ruta si es necesario 
          console.error('Error al subir el video:', error);
        }
        setShowErrorToast(true)
      } finally {
        setIsLoading(false); // Ocultar el spinner al finalizar la carga
        setRequiredErrorToast(false)
      }
    }
  }


  // Función para agregar una carretera
  const agregarCarretera = () => {
    // Actualiza el estado de "carreteras"
    setCarreteras(prevCarreteras => [...prevCarreteras, {
      id: Date.now(),
      nombre: formularioCarretera.nombre,
      tipo: formularioCarretera.tipo,
      cantCarriles: formularioCarretera.cantCarriles,
      concesion: formularioCarretera.concesion,
      isNew: 1, // Indica que este registro es nuevo
    }]);

    // Actualiza el estado de "carreteraIndex"
    setCarreteraIndex(prevCarreteraIndex => prevCarreteraIndex + 1);

    // Restablece el formulario de carretera
    setFormularioCarretera({
      id: Date.now(),
      nombre: '',
      tipo: '',
      cantCarriles: '',
      concesion: '',
      isNew: 1,
    });
  };


  // Función para eliminar la última carretera 
  const eliminarUltimaCarretera = () => {
    // Verifica si la última carretera es nueva (isNew === 1) y si hay al menos una carretera
    if (carreteras.length > 0 && carreteras[carreteras.length - 1].isNew === 1) {
      // Elimina la última carretera del array
      setCarreteras(prevCarreteras => prevCarreteras.slice(0, -1));

      // Actualiza carreteraIndex si es necesario
      setCarreteraIndex(prevCarreteraIndex => prevCarreteraIndex - 1);
    }
    setVisible(false);
  };

  const handleDeleteUltimaCarretera = (id) => {

    setVisible(true);

  };

  const handleDeleteCarretera = async (carreteraIndex) => {
    setVisible(true); // Abre el modal de confirmación

    const confirmed = new Promise((resolve) => {
      const handleModalClose = (isConfirmed) => {
        setVisible(false);
        resolve(isConfirmed);
        window.removeEventListener('modalClose', handleModalClose);
      };

      window.addEventListener('modalClose', (event) => {
        handleModalClose(event.detail.confirmed);
      });
    });

    const isConfirmed = await confirmed;

    if (isConfirmed) {
      setIsLoading(true);
      const carreteraAEliminar = carreteras[carreteraIndex];

      if (carreteraAEliminar.isNew === 1) {
        setCarreteras(prevCarreteras => prevCarreteras.filter((_, i) => i !== carreteraIndex));
        setIsLoading(false);
      } else {
        try {
          const token = localStorage.getItem('token');
          const response = await axios.delete(
            `${process.env.REACT_APP_API_BASE_URL}/api/carretera-delete/${carreteraAEliminar.id}`,
            {
              headers: {
                'Authorization': 'Bearer ' + token,
              },
            }
          );

          if (response.status === 200) {
            setCarreteras(prevCarreteras => prevCarreteras.filter((_, i) => i !== carreteraIndex));
            setShowSuccessToast(true);
          }
        } catch (error) {
          console.error('Error al eliminar la carretera:', error);
          setShowErrorToast(true);
        } finally {
          setIsLoading(false);
        }
      }
    }
  };



  return (
    <>
      <CRow className='margin-row-contenedor'>
        <CCol xs>
          <CCol xs='12' className='d-flex align-items-center padding-titulo-list-contenedor'>
            <CIcon onClick={handleGoBack} icon={cilArrowLeft} size="xxl" className="height-auto icon-background-orange cursor-pointer" style={{ '--ci-primary-color': 'white' }} /><h5 className='margin-bottom-h5'><strong>Editar Proyecto</strong></h5>
          </CCol>
          <CCol xs={10} style={{ 'height': '29rem' }}>
            <CCard className="mb-4 scroll-contenedor-new-proyect" style={{ 'height': '500px' }}>
              <CCol xs={10} className='titulo-formulario-new-proyect'>Proyecto ID #</CCol>
              <CCardBody>
                <CForm onSubmit={handleSubmit}>
                  <div className="mb-3 letra-contenido-2">
                    <CRow>
                      <CCol xs={10}>
                        <CFormLabel htmlFor="nombreProyecto1">Nombre de proyecto</CFormLabel>
                        <CFormInput className='letra-contenido-modal-input' size="sm" id="nombreProyecto1" placeholder="Ingrese nombre" value={nombreProyecto1} onChange={(e) => {
                          // Actualiza el estado del formulario

                          setNombreProyecto1(e.target.value);

                          // Elimina el error si se corrige el campo
                          if (e.target.value) {
                            setErrors(prevErrors => ({
                              ...prevErrors,
                              [`nombreProyecto1`]: undefined
                            }));
                          }
                        }} />
                        {errors.nombreProyecto1 && <div className="text-danger">{errors.nombreProyecto1}</div>} {/* Mostrar error */}
                      </CCol>
                    </CRow>
                  </div>

                  <div className="mb-3 letra-contenido-2">
                    <CRow>
                      <CCol xs={4}>
                        <CFormLabel htmlFor="alturaCenital1">Altura de Cámara Cenital(cm)</CFormLabel>
                        <CFormInput className='letra-contenido-modal-input' size="sm" id="alturaCenital1" required placeholder="Ingrese altura" value={alturaCenital1} onChange={(e) => {
                          // Actualiza el estado del formulario

                          setAlturaCenital1(e.target.value);

                          // Elimina el error si se corrige el campo
                          if (e.target.value) {
                            setErrors(prevErrors => ({
                              ...prevErrors,
                              [`alturaCenital1`]: undefined
                            }));
                          }
                        }} />
                        {errors.alturaCenital1 && <div className="text-danger">{errors.alturaCenital1}</div>} {/* Mostrar error */}
                      </CCol>
                      <CCol xs={3}>
                        <div>
                          <div className="datePicker-container"> {/* Contenedor para label y DatePicker */}
                            <CFormLabel htmlFor="fecha-inicio">Fecha de ejecución inicio</CFormLabel>
                            <DatePicker
                              ref={datePickerRef}
                              id="fecha-inicio"
                              selected={selectedDate}
                              onChange={(date) => { // Obtén la fecha directamente del argumento
                                setSelectedDate(date);

                                // Elimina el error si se selecciona una fecha
                                if (date) {
                                  setErrors(prevErrors => ({
                                    ...prevErrors,
                                    selectedDate: undefined // Corrige la clave aquí
                                  }));
                                } else {
                                  // Puedes agregar aquí la lógica para mostrar un error 
                                  // si el usuario elimina la fecha seleccionada, si es necesario
                                  setErrors(prevErrors => ({
                                    ...prevErrors,
                                    selectedDate: "Este campo es requerido"
                                  }));
                                }
                              }}
                              customInput={
                                <CustomInput
                                  value={selectedDate ? selectedDate.toLocaleDateString() : ""}
                                  onChange={setSelectedDate}
                                  onFocus={handleFocus}
                                />
                              }
                            />
                            {errors.selectedDate && <div className="text-danger">{errors.selectedDate}</div>} {/* Mostrar error */}
                          </div>
                        </div>
                      </CCol>
                      <CCol xs={3}>
                        <div>
                          <div className="datePicker-container"> {/* Contenedor para label y DatePicker */}
                            <CFormLabel htmlFor="fecha-inicio">Fecha de ejecución fin</CFormLabel>
                            <DatePicker
                              ref={datePickerRef2}
                              id="fecha-inicio"
                              selected={selectedDate2}
                              onChange={(date) => { // Obtén la fecha directamente del argumento
                                setSelectedDate2(date);

                                // Elimina el error si se selecciona una fecha
                                if (date) {
                                  setErrors(prevErrors => ({
                                    ...prevErrors,
                                    selectedDate2: undefined // Corrige la clave aquí
                                  }));
                                } else {
                                  // Puedes agregar aquí la lógica para mostrar un error 
                                  // si el usuario elimina la fecha seleccionada, si es necesario
                                  setErrors(prevErrors => ({
                                    ...prevErrors,
                                    selectedDate2: "Este campo es requerido"
                                  }));
                                }
                              }}
                              customInput={
                                <CustomInput
                                  value={selectedDate2 ? selectedDate2.toLocaleDateString() : ""}
                                  onChange={setSelectedDate2}
                                  onFocus={handleFocus2}
                                />
                              }
                            />
                            {errors.selectedDate2 && <div className="text-danger">{errors.selectedDate2}</div>} {/* Mostrar error */}
                          </div>
                        </div>
                      </CCol>
                    </CRow>
                  </div>

                  <div className="mb-3 letra-contenido-2">
                    <CRow>
                      <CCol xs={5}>
                        <CFormLabel htmlFor="cliente1">Cliente</CFormLabel>
                        <CFormInput className='letra-contenido-modal-input' size="sm" id="cliente1" placeholder="Ingrese" value={cliente1} onChange={(e) => {
                          // Actualiza el estado del formulario

                          setCliente1(e.target.value);

                          // Elimina el error si se corrige el campo
                          if (e.target.value) {
                            setErrors(prevErrors => ({
                              ...prevErrors,
                              [`cliente1`]: undefined
                            }));
                          }
                        }} />
                        {errors.cliente1 && <div className="text-danger">{errors.cliente1}</div>} {/* Mostrar error */}
                      </CCol>

                      <CCol xs={5}>
                        <CFormLabel htmlFor="operador1">Operador</CFormLabel>
                        <CFormInput className='letra-contenido-modal-input' size="sm" id="operador1" placeholder="Ingrese" value={operador1} onChange={(e) => {
                          // Actualiza el estado del formulario

                          setOperador1(e.target.value);

                          // Elimina el error si se corrige el campo
                          if (e.target.value) {
                            setErrors(prevErrors => ({
                              ...prevErrors,
                              [`operador1`]: undefined
                            }));
                          }
                        }} />
                        {errors.operador1 && <div className="text-danger">{errors.operador1}</div>} {/* Mostrar error */}
                      </CCol>
                    </CRow>
                  </div>

                  <div className="mb-3 letra-contenido-2">
                    <CRow>
                      <CCol xs={10}>
                        <CFormLabel htmlFor="descripcion1">Descripción</CFormLabel>
                        <CFormTextarea
                          className='letra-contenido-modal-input'
                          id="exampleFormControlTextarea1"
                          placeholder="Escribe comentarios u observaciones"
                          value={descripcion1}
                          onChange={(e) => setDescripcion1(e.target.value)}
                          rows={4}
                        ></CFormTextarea>
                      </CCol>
                    </CRow>
                  </div>
                  <hr className='width-hr-form-new-proyect'></hr>
                  {carreteras.map((carretera, carreteraIndex) => (
                    <div key={carretera.id}>
                      {/* Mostrar la información de la carretera */}
                      <CRow>
                        <CCol xs={10}>
                          <CRow className='align-items-center justify-content-between'> {/* Alinear elementos verticalmente y horizontalmente */}
                            <CCol xs={8} className='titulo-formulario-new-carretera'>
                              Carretera #{carreteraIndex + 1}
                              {/* {carreteraIndex === carreteras.length - 1 && carretera.isNew === 1 && ( */}
                              <CButton
                                className="btn-delete-orange"
                                onClick={() => handleDeleteCarretera(carreteraIndex)}
                              >
                                <img src={trash} alt="Selected Image" className="icon-delete-collapse" />
                              </CButton>
                              {/* )} */}
                            </CCol>
                            <CCol xs={1} className="justify-content-end"> {/* Alinea el botón a la derecha */}

                            </CCol>
                          </CRow>
                        </CCol>
                      </CRow>

                      {/* Formulario de Carretera */}
                      <div className="mb-3 letra-contenido-2">
                        <CRow>
                          <CCol xs={10} className='letra-contenido-2'>
                            <CFormInput className='letra-contenido-modal-input' size="sm" id="idCarretera" placeholder="Ingrese nombre" value={carretera.id} hidden onChange={(e) => setIdCarreteras(prevCarreteras => prevCarreteras.map((c, i) => i === carreteraIndex ? { ...c, id: e.target.value } : c))} />
                          </CCol>
                        </CRow>
                      </div>
                      <div className="mb-3 letra-contenido-2">
                        <CRow>
                          <CCol xs={10} className='letra-contenido-2'>
                            <CFormLabel htmlFor="nombreCarretera">Nombre de carretera/ruta</CFormLabel>
                            <CFormInput className='letra-contenido-modal-input' size="sm" id="nombreCarretera" placeholder="Ingrese nombre" value={carretera.nombre} onChange={(e) => {
                              // Actualiza el estado del formulario
                              setCarreteras(prevCarreteras =>
                                prevCarreteras.map((c, i) =>
                                  i === carreteraIndex ? { ...c, nombre: e.target.value } : c
                                )
                              );

                              // Elimina el error si se ingresa un valor
                              if (e.target.value) {
                                setErrors(prevErrors => ({
                                  ...prevErrors,
                                  [`nombreCarreteraError${carreteraIndex}`]: undefined
                                }));
                              }
                            }}
                            />

                            {errors[`nombreCarreteraError${carreteraIndex}`] && (
                              <div className="text-danger">{errors[`nombreCarreteraError${carreteraIndex}`]}</div>
                            )}
                          </CCol>
                        </CRow>
                      </div>
                      <div className="mb-3 letra-contenido-2">
                        <CRow>
                          <CCol xs={4}>
                            <CFormSelect size="sm"
                              className='letra-contenido-modal-input'
                              style={{ width: '100%' }}
                              label="Tipo de carretera"
                              value={carretera.tipo}
                              onChange={(e) => setCarreteras(prevCarreteras => prevCarreteras.map((c, i) => i === carreteraIndex ? { ...c, tipo: e.target.value } : c))}>
                              <option className='fuente-letra-oscura' >Seleccione tipo</option>
                              <option className='fuente-letra-oscura' value="autopista">Autopista</option>
                              <option className='fuente-letra-oscura' value="autovia">Autovia</option>
                              <option className='fuente-letra-oscura' value="carretera">Carretera</option>
                            </CFormSelect>
                          </CCol>
                          <CCol xs={3}>
                            <CFormSelect size="sm"
                              className='letra-contenido-modal-input'
                              label="Cantidad de carriles"
                              value={carretera.cantCarriles}
                              onChange={(e) => setCarreteras(prevCarreteras => prevCarreteras.map((c, i) => i === carreteraIndex ? { ...c, cantCarriles: e.target.value } : c))}>
                              <option className='fuente-letra-oscura' >Seleccione</option>
                              <option className='fuente-letra-oscura' value="1">1</option>
                              <option className='fuente-letra-oscura' value="2">2</option>
                              <option className='fuente-letra-oscura' value="3">3</option>
                              <option className='fuente-letra-oscura' value="4">4</option>
                            </CFormSelect>
                          </CCol>
                          <CCol xs={3}>
                            <CFormSelect size="sm"
                              className='letra-contenido-modal-input'
                              label="Concesión"
                              value={carretera.concesion}
                              onChange={(e) => setCarreteras(prevCarreteras => prevCarreteras.map((c, i) => i === carreteraIndex ? { ...c, concesion: e.target.value } : c))}>
                              <option className='fuente-letra-oscura' >Seleccione</option>
                              <option className='fuente-letra-oscura' value="si">Si</option>
                              <option className='fuente-letra-oscura' value="no">No</option>
                            </CFormSelect>
                          </CCol>
                        </CRow>
                      </div>
                    </div>
                  ))}
                  {/* Botón Agregar Carretera */}
                  <div className="mb-2">
                    <CRow>
                      <CCol xs={10}>
                        <CButton className="letra-btn-agregar align-inicio" onClick={agregarCarretera}>
                          <span className='align-inicio'><img src={iconImagenUpload} alt="Selected Image" className="icon-add-form mr-2" /> Agregar Carretera</span>
                        </CButton>
                        {/* Botón de eliminar la última carretera */}
                        {/* {carreteras.length > 0 && carreteras[carreteras.length - 1].isNew === 1 && (
                          <CButton
                            className="btn-delete-orange"
                            onClick={eliminarUltimaCarretera}
                          >
                            <img src={trash} alt="Selected Image" className="icon-arrow-collapse" />
                          </CButton>
                        )} */}
                        <hr></hr>
                      </CCol>
                    </CRow>

                  </div>
                </CForm>
              </CCardBody>
            </CCard>

          </CCol>
        </CCol>
      </CRow>


      {profile === 'true' ? (
        <footer className='footer-form-video-estilo'>
          <CRow>
            {/* <CCol xs='2'></CCol>  */}
            <CCol xs='12'>
              <CRow>
                <CCol xs='8' className='footer-text-save-leave letra-contenido-2'><CButton onClick={handleSubmit} className="px-8 btn-guardar-footer flex items-center justify-between" type="submit"><img src={iconCheck} alt="Selected Image" className="icon-check mr-2" /><span className='padding-separar-boton'>Guardar y salir</span></CButton></CCol>
                <CCol xs='1'>
                  <div className="">
                    <CButton href='/dashboard' className="px-8 btn-salir-footer" type="submit">Cancelar</CButton>
                  </div>
                </CCol>
                <CCol xs='1' className='padding-left-footer-next'>
                  <div className="">
                    <CButton className="px-8 btn-next-footer" type="submit">Siguiente</CButton>

                  </div>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </footer>
      ) : (
        <footer className='footer-form-video-estilo'>
          <CRow>
            <CCol xs='2'></CCol>
            <CCol xs='10'>
              <CRow>
                <CCol xs='8' className='footer-text-save-leave letra-contenido-2'><CButton onClick={handleSubmit} className="px-8 btn-guardar-footer flex items-center justify-between" type="submit"><img src={iconCheck} alt="Selected Image" className="icon-check mr-2" /><span className='padding-separar-boton'>Guardar y salir</span></CButton></CCol>
                <CCol xs='1'>
                  <div className="">
                    <CButton href='/dashboard' className="px-8 btn-salir-footer" type="submit">Cancelar</CButton>
                  </div>
                </CCol>
                <CCol xs='1' className='padding-left-footer-next'>
                  <div className="">
                    <CButton href={`/new-video2/form/${id}`} className="px-8 btn-next-footer" type="submit">Siguiente</CButton>

                  </div>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </footer>

      )}


      <CModal
        alignment="center"
        visible={visible}
        onClose={() => setVisible(false)}
        aria-labelledby="VerticallyCenteredExample"
        size='sm'
      >
        <CModalContent style={{ 'width': '400px' }}>
          <CModalHeader style={{ '--cui-modal-header-border-color': 'white' }}>
            <CModalTitle className='letra-titulo-modal' id="VerticallyCenteredExample">Eliminar Proyecto</CModalTitle>
          </CModalHeader>
          <CModalBody className='letra-contenido-modal'>
            Estas por eliminar esta carretera, Y no ha sido guardada aun.
            ¿Estas seguro que deses eliminarla?
          </CModalBody>
          <CModalFooter style={{ '--cui-modal-footer-border-color': 'white' }}>
            {/* <CButton className='btn-salir-footer' onClick={() => setVisible(false)}>
              Cancelar
            </CButton>
            <CButton className='btn-next-footer' onClick={eliminarUltimaCarretera}>Aceptar</CButton> */}
            <CButton className='btn-salir-footer' onClick={() => {
              const event = new CustomEvent('modalClose', { detail: { confirmed: false } });
              window.dispatchEvent(event);
            }}>Cancelar</CButton>
            <CButton className='btn-next-footer' onClick={() => {
              const event = new CustomEvent('modalClose', { detail: { confirmed: true } });
              window.dispatchEvent(event);
            }}>Eliminar</CButton>
          </CModalFooter>
        </CModalContent>
      </CModal>


      {showSuccessToast && (
        <CToast
          autohide={false}
          visible={true}
          // color="primary" 
          className="text-white align-items-center backgroundcolor-toast-exito"
          // Estilo para posicionar el toast
          style={{ position: 'fixed', top: '10px', right: '10px', zIndex: 1000 }}
        >
          <div className="d-flex">
            <CToastBody>Registro editado correctamente.</CToastBody>
            <CToastClose onClick={handleCloseToast} className="me-2 m-auto" white />
          </div>
        </CToast>
      )}
      {showErrorToast && (
        <CToast
          autohide={false}
          visible={true}
          // color="primary" 
          className="text-white align-items-center backgroundcolor-toast-error"
          // Estilo para posicionar el toast
          style={{ position: 'fixed', top: '10px', right: '10px', zIndex: 1000 }}
        >
          <div className="d-flex">
            <CToastBody>Ha ocurrido un Error.</CToastBody>
            <CToastClose onClick={handleCloseToastError} className="me-2 m-auto" white />
          </div>
        </CToast>
      )}

      {showRequiredToast && (
        <CToast
          autohide={false}
          visible={true}
          // color="primary" 
          className="text-white align-items-center backgroundcolor-toast-error"
          // Estilo para posicionar el toast
          style={{ position: 'fixed', top: '10px', right: '10px', zIndex: 1000 }}
        >
          <div className="d-flex">
            <CToastBody>Verificar Los Campos Obligatorios.</CToastBody>
            <CToastClose onClick={handlerequiredFields} className="me-2 m-auto" white />
          </div>
        </CToast>
      )}

      {isLoading && ( // Mostrar el spinner solo si isLoading es true
        <div className="loading-overlay">
          <CSpinner color="primary" />
        </div>
      )}
    </>
  );
}


FormVideo.propTypes = {
  setProfile: PropTypes.func.isRequired

}

export default FormVideo;